import React from "react";
import { Typography } from "antd";
import styles from "./StoreDetail.module.scss";
import CategoryLevels from "../../../components/categorylevels/CategoryLevels";
export interface TopRankItem {
  nombre: string;
  venta: number;
  categoryLevels?: string[] | null;
}

const { Text } = Typography;

const fmt = (v: number) =>
  `$ ${v.toLocaleString("es-AR", { maximumFractionDigits: 0 })}`;

interface StoreRankListProps {
  items: TopRankItem[];
}

const StoreRankList: React.FC<StoreRankListProps> = ({ items }) => {
  const maxVenta = Math.max(...items.map((i) => i.venta), 1);

  return (
    <div
      className={`${styles.rankList} ${
        items.length > 10 ? styles.scrollList10 : ""
      }`}
    >
      {items.map((item, index) => (
        <div key={`${index}-${item.nombre}`} className={styles.rankRow}>
          <div className={styles.rankBadge}>{index + 1}</div>
          <div className={styles.rankContent}>
            <div className={styles.rankHeader}>
              <Text className={styles.rankName}>
                {item.categoryLevels?.length ? (
                  <CategoryLevels levels={item.categoryLevels} />
                ) : (
                  item.nombre
                )}
              </Text>
              <Text className={styles.rankValue}>{fmt(item.venta)}</Text>
            </div>
            <div className={styles.rankBarTrack}>
              <div
                className={styles.rankBarFill}
                style={{ width: `${(item.venta / maxVenta) * 100}%` }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StoreRankList;
